import React, { Component } from "react";

// React Router
import { withRouter } from "react-router-dom";

// Components
import Viewer from "../../static/img/Bitmap.svg";
import Logout from "../../static/img/logoutIcons.svg"

// Styles
import "./HeaderView.scss";

// Icons

// Sounds
class HeaderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMusicOn: true,
    };
  }

 
  render() {

    return (
      <div className="header-viewer">
         {/* <div className="header-view-content"> */}
             <p className="step-num">4/5 <span className="codeberry" >CodeBerry</span> </p>
             <div className="image-container"><img src={Viewer} alt="viewer" /></div>
             <div className="image-container2"><img src={Logout} alt="logout" /></div>
         {/* </div> */}
      </div>
    );
  }
}
export default withRouter(HeaderView);
